import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import RmDrawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import Loader from '../loader';
import { Box, useTheme } from '@mui/material';
import useQueryHelper from '../../hooks/use-query-helper';
import { DRAWER_ANIMATE_DURATION, DrawerProps, DrawerSizeMap } from './helpers';
import useIntercom from '@/hooks/use-intercom.hook';
import NotFoundDrawer from './not-found';

interface Props extends DrawerProps {
  children: ReactNode;
}

const useStyles = createUseStyles<string, { bannerSize: number }>({
  drawer: ({ bannerSize }) => ({
    position: 'relative',
    padding: '20px 0px',
    boxSizing: 'border-box',
    paddingTop: bannerSize + 21,
    '& form': {
      height: 'auto',
    },
    maxWidth: '100%',
  }),
  inner: {
    height: '100%',
    width: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
});

const Drawer: FC<Props> = ({
  children,
  open,
  className = '',
  onClose,
  query,
  loading = false,
  size = 'small',
  isTopDrawer = false,
}) => {
  const { bannerSize } = useIntercom();
  const styles = useStyles({ bannerSize });
  const compClass = classNames(styles.drawer, className);
  const theme = useTheme();

  const { showLoader, showNotFound } = useQueryHelper(query, loading);
  const compShowLoader = open && showLoader;
  const compShowNotFound = open && showNotFound;
  const compShowChildren = !compShowLoader && !compShowNotFound;

  return (
    <RmDrawer
      direction="right"
      className={compClass}
      open={open}
      overlayOpacity={0}
      duration={DRAWER_ANIMATE_DURATION}
      size={DrawerSizeMap[size]}
      zIndex={theme.zIndex.drawer}
      onClose={() => onClose()}
    >
      <Box className={styles.inner}>
        {compShowLoader && <Loader />}
        {compShowNotFound && <NotFoundDrawer onClose={onClose} isTopDrawer={isTopDrawer} />}
        {compShowChildren && children}
      </Box>
    </RmDrawer>
  );
};

export default Drawer;
